import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControl,
  Select,
  MenuItem
} from '@material-ui/core'
import { formStyles } from '../../Invoice/Steps/FormStyles'

const InvoicesStatusForm = ({ onSubmit, listingFiltersBackup }) => {
  const classes = formStyles()
  const intl = useIntl()
  const [value, setValue] = React.useState('')

  const invoicesTypes = [
    {
      key: 'SUBMISSION COMPLETE',
      name: intl.formatMessage({ id: 'invoicesStatus.submitted' })
    },
    {
      key: 'other',
      name: intl.formatMessage({ id: 'invoicesStatus.others' })
    }
  ]
  const handleSelectChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setValue(event.target.value.toString())
    onSubmit(event.target.value.toString())
  }
  React.useEffect(() => {
      if (!!listingFiltersBackup?.spStatus) {
        setValue('')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingFiltersBackup])
  return (
    <form noValidate autoComplete="off" className={classes.formWrapper}>
      <div className={classes.FormItem + ' ' + classes.FormRow}>
        <FormControl variant="outlined" className={classes.FormItemSelect}>
          <Select
            fullWidth
            displayEmpty
            labelId={'spStatus-label'}
            id={'spStatus'}
            name={'spStatus'}
            margin={'dense'}
            variant='outlined'
            MenuProps={{ disableScrollLock: true }}
            value={value}
            // label={intl.formatMessage({ id: 'Fields.label.view.InvoiceDirection' })}
            onChange={handleSelectChange}
          >
            <MenuItem value={''}>
              <div className={classes.invoiceDirectionWrapper}>
                <FormattedMessage id={'Table.List.Table.All'}/>
              </div>
            </MenuItem>
            {!!invoicesTypes?.length && invoicesTypes.map((item) => (
              <MenuItem key={item.key} value={item.key}>
                <div className={classes.invoiceDirectionWrapper}>{item.name}</div>
              </MenuItem>))}
          </Select>
        </FormControl>
      </div>
    </form>
  )
}

export default InvoicesStatusForm
